<template>
    <!-- 城市选择 -->
    <div @click="setEditIndex(index)">
        <el-row :gutter="10" style="margin-left:5px">
            <!-- <h1>{{question.choiceRange}}</h1> -->
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                <!-- <span>{{titleNumber+1}}</span> -->
                 {{number}}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
                <el-input placeholder="请输入题目内容" @focus="showAdvance" @blur="updateQuestion()" v-model="question.questionsName" autosize></el-input>
            </el-col>
            <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <i class="el-icon-delete delete" v-if="index==editIndex" @click="questiondel(question.id)"></i>
                <el-badge 
                    v-if="question.displayscriptcount || question.jumpscriptcount" 
                    :value="question.displayscriptcount + question.jumpscriptcount" 
                    class="item">
                    <i
                        class="el-icon-share"
                        @click="()=>$emit('jumpshow',question.id)"
                    ></i>
                </el-badge>
                <i class="el-icon-rank item drag-handle"></i>
            </el-col>
        </el-row>
        

        <el-row :gutter="10" style="margin-top:12px; margin-bottom:20px">
            <div>
                <div  style="margin-left:50px">
                    <!-- <div class='selectCity'>
                        <input type="text" placeholder="请选择省份" v-if="detailprov == true">
                        <input type="text" placeholder="请选择城市" v-if="detailContry == true">
                        <input type="text" placeholder="请选择区/县" v-if="detailQU == true">
                    </div>
                    <input class='addres' type="text" v-if="detailCity == true" placeholder="请填写详细地址"> -->

                    <div class='selectCity'>
                        <fake-input class="inputvalue" placeholder="请选择省份" />
                        <fake-input class="inputvalue" placeholder="请选择城市" v-if="question.choiceRange <3" />
                        <fake-input class="inputvalue" placeholder="请选择区/县" v-if="question.choiceRange <2" />
                    </div>
                    <fake-textarea class='addres' v-if="question.choiceRange <1" placeholder="请填写详细地址"/>
                </div>
            </div>
        </el-row>

        
    </div>
</template>
<script>
    import FakeInput from './FakeInput.vue';
    import FakeTextarea from './FakeTextarea.vue'
    export default {
        components:{
            FakeInput,
            FakeTextarea
        },
        data() {
            return {
                editOptionIndex: "0_0",
                input:"",
                input1:'',
                input2:'',
                input3:'',
                detailCity:true,
                detailQU:true,
                detailContry:true,
                detailprov:true
            }
        },
        props: {
			number: { type: Number, default: 0 },
            radioChoice:[String, Number],
            question: {},
            editIndex: {type:Number,default:0},
            index: {type:Number,default:0},
            isExistPage: {type:Boolean,default:false},
            titleNumber:{type:Number,default:0}
        },
        
        methods: {
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            updateQuestion(){
                this.$emit("wjupdquestionoption",this.question);
            },
            wjaddquestionoption(optionList, item, type = 1) {
                this.$emit("wjaddquestionoption", optionList, item, type);
            },
            showAdvance(e) {
                this.$emit("showAdvance",e);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            setEditOptionIndex(childIndex){
                this.editOptionIndex = this.editIndex+"_"+childIndex;
            },
            wjdelquestionoption(options,item,childindex){
                this.$emit("wjdelquestionoption",options,item,childindex)
            },
            questiondel(id){
                this.$emit("questiondel",id);
            }
        },
        created() {
            console.log('questionCity',this.question)
            this.$emit('questiontitle',this.titleNumber)
            if(this.question.choiceRange == 1){
                this.detailCity = false
            }else if(this.question.choiceRange == 2){
                this.detailCity = false
                this.detailQU = false
            }else if(this.question.choiceRange == 3){
                this.detailCity = false
                this.detailQU = false
                this.detailContry = false
            }
            
        },
        
    }
</script>

<style scoped>
    .selectCity{
        display:flex;
        flex-direction: column;
    }
    .selectCity .inputvalue{
        width:400px;
        height:30px;
        line-height: 30px;
        border:1px solid #ccc !important;
        border-radius: 4px;
        margin-top:10px;
        text-indent: 20px;
    }
    .addres{
        width:400px;
        height:70px;
        border:1px solid #ccc !important;
        border-radius: 4px;
        margin-top:10px;
        text-indent: 20px;
    }
    .inputvalue{
        border: 1px solid rgb(154, 145, 145);
        width: 770px;
        height: 40px;
    }
    /* .el-input__inner{
        height:35px;
    } */
    /deep/.questionCity.el-input__inner:hover{
        border:none !important;
    }
    .delete,.item {
        font-size: 22px !important;
        line-height: 40px !important;
        margin-right: 30px !important;
        text-align: right;
        float: right;
        cursor: pointer;
    }
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .askxh {
        line-height: 40px;
        text-align: right;
    }

    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }


    .item_container_title:hover {
    //border: 1px darkgrey dashed;

    }
</style>
